import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { listRankingRuns } from "../../api/clientVendorDirectoryRankingApi";
import ClientVendorDirectorySubnav from "../../components/casamap/admin/ClientVendorDirectorySubnav";
import ClientVendorDirectoryRankingSubnav from "../../components/casamap/admin/ClientVendorDirectoryRankingSubnav";
import { ClientPortalError, ClientPortalLoading } from "../../components/clientPortal/ClientPortalStates";
import { formatClientDate, formatStatusLabel } from "../../utils/clientPortalFormat";
import { useLocale } from "../../intl";
import "../../styles/casamapaVendorDirectoryAdmin.css";

const COPY_PREFIX = "realEstate.casaMapa.admin.vendorDirectoryWorkspace.ranking.runs";

export default function ClientVendorDirectoryRankingRunListPage() {
  const { clientViewId } = useParams();
  const { t, locale } = useLocale();
  const [runs, setRuns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const body = await listRankingRuns(clientViewId);
      setRuns(body.runs || []);
    } catch (error) {
      setErrorMessage(error.message || t(`${COPY_PREFIX}.loadError`));
    } finally {
      setLoading(false);
    }
  }, [clientViewId, t]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <div className="page-content cvd-admin">
      <ClientVendorDirectorySubnav clientViewId={clientViewId} />
      <ClientVendorDirectoryRankingSubnav clientViewId={clientViewId} />
      <h1 className="cvd-admin__title">{t(`${COPY_PREFIX}.title`)}</h1>
      {loading ? <ClientPortalLoading message={t(`${COPY_PREFIX}.loading`)} /> : null}
      {errorMessage ? <ClientPortalError message={errorMessage} onRetry={load} /> : null}
      {!loading && !errorMessage ? (
        <div className="cvd-table-wrap">
          <table className="cvd-table">
            <thead>
              <tr>
                <th>{t(`${COPY_PREFIX}.table.status`)}</th>
                <th>{t(`${COPY_PREFIX}.table.scope`)}</th>
                <th>{t(`${COPY_PREFIX}.table.evaluated`)}</th>
                <th>{t(`${COPY_PREFIX}.table.eligible`)}</th>
                <th>{t(`${COPY_PREFIX}.table.snapshots`)}</th>
                <th>{t(`${COPY_PREFIX}.table.started`)}</th>
              </tr>
            </thead>
            <tbody>
              {runs.map((run) => (
                <tr key={run.id}>
                  <td>{formatStatusLabel(run.status)}</td>
                  <td>{run.scope_type}</td>
                  <td>{run.vendors_evaluated}</td>
                  <td>{run.vendors_eligible}</td>
                  <td>{run.snapshots_created}</td>
                  <td>{run.started_at ? formatClientDate(run.started_at, locale) : "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : null}
    </div>
  );
}
